module.exports = __webpack_public_path__ + "assets/img/live-broadcast-icon3.a01c0e01.png";